var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col bottom-0 fixed w-full bg-white items-center text-center"},[_c('span',{staticClass:"mb-4 text-sm"},[_vm._v("Powered by "),_c('strong',[_vm._v("Tappin AS")])]),_c('img',{staticClass:"h-6 w-auto mb-4",attrs:{"src":"/assets/tappin-logo.png"}})])
}]

export { render, staticRenderFns }